import script from "./SupportsViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportsViewPage.vue?vue&type=script&setup=true&lang=js"

import "./SupportsViewPage.vue?vue&type=style&index=0&id=42fe0ae6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42fe0ae6"]])

export default __exports__